module.exports = __webpack_public_path__ + "img/whatsapp.743f2b02.png";